import React from 'react';
import { motion } from 'framer-motion';
import { letters, LaoLetter } from '../data/letters';
import { numbers, LaoNumber } from '../data/numbers';

interface LetterGridProps {
  mode: 'letters' | 'numbers';
  onSelect: (item: LaoLetter | LaoNumber) => void;
  onBack: () => void;
  speak: (text: string) => void;
}

const LetterGrid: React.FC<LetterGridProps> = ({ mode, onSelect, onBack, speak }) => {
  const items = mode === 'letters' ? letters : numbers;

  const getChar = (item: LaoLetter | LaoNumber) =>
    'char' in item ? item.char : item.laoChar;

  const getEmoji = (item: LaoLetter | LaoNumber) => item.emoji;

  const getName = (item: LaoLetter | LaoNumber) => item.name;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-blue-100 via-white to-green-100 p-4 pb-24"
    >
      <div className="flex items-center justify-between mb-6">
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={onBack}
          className="bg-white rounded-full shadow-md px-5 py-3 text-xl font-bold text-gray-600"
        >
          ← ກັບຄືນ
        </motion.button>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-700">
          {mode === 'letters' ? 'ພະຍັນຊະນະລາວ' : 'ຕົວເລກລາວ'}
        </h2>
        <div className="w-20" />
      </div>

      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-3 max-w-4xl mx-auto">
        {items.map((item, index) => (
          <motion.button
            key={getChar(item)}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.03, type: 'spring', stiffness: 200 }}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              speak(getName(item));
              onSelect(item);
            }}
            className={`${item.color} rounded-2xl shadow-lg p-3 flex flex-col items-center justify-center min-h-[100px] min-w-[80px] text-white active:shadow-inner`}
          >
            <span className="text-4xl md:text-5xl font-bold leading-none">
              {getChar(item)}
            </span>
            <span className="text-2xl mt-1">{getEmoji(item)}</span>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default LetterGrid;
